@if (treeResult) {
    @if (flatResult) {
        <his-bi-flat-table-toolbar
            [rowcount]="flatResult.treeNodeCount"
            [treeTable]="true"
            [(filterActive)]="filterActive"
            (resetFilter)="tt.filters = {}; tt.filter('', '', '')"
            (toggleTree)="toggleTree($event.state)">
        </his-bi-flat-table-toolbar>
    }
    <p-treeTable
        #tt
        [paginator]="rowsCount / treeResult.length < 1"
        [rows]="rowsCount"
        [sortMode]="sortMode"
        [totalRecords]="rowsExpandedCount"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [value]="treeResult"
        [lazy]="false"
        [columns]="cols"
        [reorderableColumns]="reorderingAllowed()"
        (onColReorder)="columnsReorderedFromTemplate($event)"
        [multiSortMeta]="multiSortMeta"
        class="tableStickyHeader"
        (onNodeExpand)="onNodeExpand($event)"
        (onNodeCollapse)="onNodeCollapse($event)"
        [class.frozenCol]="groupableColCount === 1"
        [showGridlines]="true">
        <!-- Header bestehend aus Attributspalten (Zeilen können gruppiert werden) und dem hierarchisch aufgebauten Kennzahlenspalten -->
        <ng-template
            pTemplate="header"
            let-columns="cols">
            <!-- Für Berichte wie den Projektfinanzbericht (column header) -->
            @if (!tableHeader) {
                <tr>
                    @for (col of cols; track col) {
                        @if (col.groupable) {
                            <th
                                [ttSortableColumn]="col.field"
                                [ttSortableColumnDisabled]="
                                    col.type === columnType.DetailColumn ||
                                    col.type === columnType.EditColumn
                                "
                                ttReorderableColumn>
                                {{ col.header }}
                                @if (
                                    !(
                                        col.type === columnType.DetailColumn ||
                                        col.type === columnType.EditColumn
                                    )
                                ) {
                                    <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                                }
                            </th>
                        }
                        @if (!col.groupable) {
                            <th [ttSortableColumn]="col.field">
                                {{ col.header }}
                                <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                            </th>
                        }
                    }
                </tr>
            }
            <!-- Header für die BI-Analysen (row header)-->
            @if (tableHeader) {
                @for (row of tableHeader.headerRows; track row) {
                    <tr>
                        @for (element of row.headerElements; track element) {
                            <!-- Attributsspalten bei denen die Zeilen gruppierbar sind. Es können Sortierspalten angegeben werden -->
                            @if (element.column && element.column.groupable) {
                                <th
                                    [attr.rowspan]="element.rowspan"
                                    [attr.colspan]="element.colspan"
                                    [ttSortableColumn]="
                                        element.column.refColumnField ?? element.column.field
                                    "
                                    [ttSortableColumnDisabled]="
                                        !element.sortIcon ||
                                        element.column.type === columnType.DetailColumn ||
                                        element.column.type === columnType.EditColumn
                                    "
                                    ttReorderableColumn>
                                    {{ element.caption }}
                                    @if (
                                        element.sortIcon &&
                                        !(
                                            element.column.type === columnType.DetailColumn ||
                                            element.column.type === columnType.EditColumn
                                        )
                                    ) {
                                        <p-treeTableSortIcon
                                            [field]="
                                                element.column.refColumnField ??
                                                element.column.field
                                            "></p-treeTableSortIcon>
                                    }
                                </th>
                            }
                            <!-- Kennzahlenspalten bzw. Spalten die nicht gruppierbar sind -->
                            @if (element.column && !element.column.groupable) {
                                <th
                                    [attr.rowspan]="element.rowspan"
                                    [attr.colspan]="element.colspan"
                                    [ttSortableColumn]="element.column.field"
                                    [ttSortableColumnDisabled]="
                                        !element.sortIcon ||
                                        element.column.type === columnType.DetailColumn ||
                                        element.column.type === columnType.EditColumn
                                    "
                                    class="textAlignRight">
                                    {{ element.caption }}
                                    @if (
                                        element.sortIcon &&
                                        !(
                                            element.column.type === columnType.DetailColumn ||
                                            element.column.type === columnType.EditColumn
                                        )
                                    ) {
                                        <p-treeTableSortIcon
                                            [field]="
                                                element.column.refColumnField ??
                                                element.column.field
                                            "></p-treeTableSortIcon>
                                    }
                                </th>
                            }
                        }
                    </tr>
                }
            }
            <!-- Suchbegriffzellen für die Attributsspalten -->
            @if (filterActive) {
                <tr>
                    @for (col of cols; track col) {
                        <th>
                            @if (col.groupable) {
                                <div>{{ "cs.bia.common.search" | hisUi }}</div>
                            }
                            @if (col.groupable) {
                                <input
                                    #filterInput
                                    pInputText
                                    type="text"
                                    class="p-column-filter"
                                    placeholder="{{ 'cs.bia.common.search' | hisUi }}"
                                    (input)="tt.filter(filterInput.value, col.field, 'contains')"
                                    [value]="
                                        tt.filters[col.field] ? tt.filters[col.field]?.value : ''
                                    " />
                            }
                        </th>
                    }
                </tr>
            }
        </ng-template>
        <!-- Zeilen welche guppiert werden können (ausklappbar) -->
        <ng-template
            pTemplate="body"
            let-rowNode
            let-rowData="rowData">
            <tr [ngClass]="'level_' + rowNode.level">
                @for (col of cols; track col; let i = $index) {
                    <!-- Erste Spalte mit Button zum aufklappen -->
                    @if (i === 0) {
                        <td>
                            <div class="tree-toggler-grid-container">
                                <div class="tree-toggler-grid-item">
                                    <p-treeTableToggler
                                        [rowNode]="rowNode"
                                        [buttonTitle]="rowNode.node?.data?.defaulttext">
                                    </p-treeTableToggler>
                                </div>
                                <div class="tree-toggler-grid-item">
                                    {{ rowData[col.field] }}
                                </div>
                            </div>
                        </td>
                    }
                    <!-- Zellen die nicht aufklappbar sind und Kennzahlenspalten -->
                    @else {
                        <!-- Zelle enthält Zahl -->
                        @if (isNumberCol(col)) {
                            <td style="text-align: right">
                                {{
                                    col.type === columnType.DecimalColumn
                                        ? (rowData[col.field] | number: "1.2-2" : "de")
                                        : (rowData[col.field] | number: "1.0-2" : "de")
                                }}
                            </td>
                        } @else if (col.type === columnType.MinuteAndSecondColumn) {
                            <td style="text-align: right">
                                {{ rowData[col.field] | minuteSecondPipe }}
                            </td>
                        } @else {
                            <!-- Reguläre Zelle -->
                            <td>
                                {{ rowData[col.field] }}
                            </td>
                        }
                    }
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td [attr.colspan]="colSpanTotalsRow">{{ "cs.bia.analysis.total" | hisUi }}</td>
                @for (col of cols; track col) {
                    @if (col.groupable === false) {
                        <td style="text-align: right">
                            @if (this.totalsRow?.cells[col.field] !== null) {
                                @if (col.aggregation === "sum") {
                                    ∑
                                } @else if (col.aggregation === "avg") {
                                    ∅
                                } @else if (col.aggregation === "count") {
                                    #
                                } @else if (col.aggregation === "distinct-count") {
                                    #
                                }

                                @if (col.type === columnType.DecimalColumn) {
                                    {{ this.totalsRow?.cells[col.field] | number: "1.2-2" : "de" }}
                                } @else if (col.type === columnType.MinuteAndSecondColumn) {
                                    {{ this.totalsRow?.cells[col.field] | minuteSecondPipe }}
                                } @else {
                                    {{ this.totalsRow?.cells[col.field] | number: "1.0-2" : "de" }}
                                }
                            }
                        </td>
                    }
                }
            </tr>
        </ng-template>
    </p-treeTable>
}
